import React from "react";
import ResultInfoText from "./ResultInfoText.js";
import { faArrowRight, faBook, faEye, faFlaskVial, faObjectGroup, faVials, faBookOpen, faAtom, faAt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ExternalLink from "../ReactionTable/externalLink.js";
import MechanismEvidence from "../ReactionTable/mechanismEvidence.js";
import renderMechanism from "../../api/renderMechanism.js";
import ReactionDisplay from "./ReactionDisplay.js";
import Tooltip from "../Tooltip.js";




function ReactionResultBox({ table, row, interactiveSearch, setMechBody, maxWidth="70px", imageScale="3.0", displayTextCol=false, navigateToRecord }) {

    function drawSelectedMechanism(marts_id) {
      renderMechanism({
        mechanism_marts_id: marts_id,
        interactiveSearch: interactiveSearch,
        setMechBody: setMechBody,
        navigateToRecord: navigateToRecord
      });
    }


    return (
      <div className="reaction-box">
        {/* Left compartment for reaction details */}
        <div className="reaction-info">
          <ResultInfoText text={"Type: " + table[row].type} row={row} />
          {(table[row].class < 3) && (<ResultInfoText text={"Class " + table[row].class} row={row} />)}
         <nobr> {(table[row].product_yield && table[row].product_yield != "?") && (<Tooltip content={`The product yield reported for those specific reaction conditions.`}><ResultInfoText text={"Yield: " + table[row].product_yield} row={row} /></Tooltip>)}</nobr>
        </div>
  
        {/* Right compartment for reaction display */}
        <div className="reaction-display">
          <ReactionDisplay table={table} row={row} interactiveSearch={interactiveSearch} maxWidth={maxWidth} imageScale={imageScale} displayTextCol={displayTextCol} />
        </div>
        <div className="reaction-source">
          <nobr>
        {table[row].condition_tags && (table[row].condition_tags.includes("nmr") && (<Tooltip content={`The product structure assignment was based on a nmr experiment.`}><FontAwesomeIcon icon={faAtom} /></Tooltip>))}
        {table[row].condition_tags && (table[row].condition_tags.includes("standard") && (<Tooltip content={`The product structure assignment was based on comparison with authentic standard.`}><FontAwesomeIcon icon={faVials} /></Tooltip>))}
        {table[row].condition_tags && (table[row].condition_tags.includes("library") && (<Tooltip content={`The product structure assignment was based on comparison with literature or database.`}><FontAwesomeIcon icon={faBookOpen} /></Tooltip>))}
        {table[row].condition_tags && (!table[row].condition_tags.includes("homology") && (<Tooltip content={`Reported experiment condititons: ${table[row].condition_tags.replaceAll(",", ", ")}`}><FontAwesomeIcon icon={faFlaskVial} /></Tooltip>))}
        {table[row].condition_tags && (table[row].condition_tags.includes("homology") && (<Tooltip content={`This is a homology-based prediction: ${table[row].condition_tags.replaceAll(",", ", ")}`}><FontAwesomeIcon icon={faObjectGroup} /></Tooltip>))}
        {!table[row].condition_tags && ((<Tooltip content={`No experimental conditions reported, probably homology-based prediction.`}><FontAwesomeIcon icon={faObjectGroup} /></Tooltip>))}
        </nobr>
        {(table[row].doi || table[row].publication) && ( <ExternalLink
                  idDiv={`goToReactionPublication${row + table[row].enzyme_marts}`}
                  externalLink={table[row].doi ? (table[row].doi.startsWith("https://doi.org/") ? table[row].doi : `https://doi.org/${table[row].doi}`) : table[row].publication}
                  icon={faBook}
                >
                  See publication for the reaction
                </ExternalLink> )}
        {table[row].mechanism_id && (
            <nobr >
            <MechanismEvidence table={table} row={row} />
            <button
              className="plane-text-button"
              style={{ padding: 0, marginRight: 5 }}
              onClick={() => drawSelectedMechanism(table[row].mechanism_marts)}><Tooltip content={`Display mechanism ${table[row].mechanism_marts}`}><FontAwesomeIcon icon={faEye} color="rgb(0,0,0,0.8)" /></Tooltip></button>
            <ExternalLink
                  idDiv={`goToMechanismPublication${row + table[row].enzyme_marts}`}
                  externalLink={table[row].mechanism_doi ? `https://doi.org/${table[row].mechanism_doi}` : table[row].mechanism_link}
                  icon={faBook}
                >
                  See publication for the mechanism
                </ExternalLink></nobr>)}
        </div>
      </div>
    );
  };



export default ReactionResultBox;